import { addMonths, format } from 'date-fns';
import { Basket, CheckoutState } from '../utils/checkoutState';
import initialBasket from './initialBasket';
import initialPaymentMethods from './initialPaymentMethods';
import initialRecurringPaymentMethods from './initialRecurringPaymentMethods';

const today = new Date();
const initialState: CheckoutState = {
  // Comment this in to always get to the shipping step right away:
  // customer: {
  //   authentication: { data: null, type: 'password' },
  //   data: {
  //     customData: null,
  //     email: 'elchamuyin@mailsac.com',
  //     firstName: 'Elcha',
  //     gender: 'f',
  //     id: 1263829,
  //     lastName: 'Muyin',
  //     publicKey: '1001263829',
  //     title: '',
  //     type: 'personal'
  //   },
  //   flags: { canUpgradeToFullAccount: false, isGuest: false, isCarrierSelectionBlocked: false },
  //   groups: ['new']
  // },
  // Comment this in to show debug info:
  // debug: [
  //   {
  //     ruleEngine: [{
  //     ruleId: 123,
  //     condition: "(application.appId = 2030)",
  //     isMatched: true,
  //     name: "Default shipping",
  //     description: "Deactivate free shipping  as long as collection point type = \"collection points\" is not selected",
  //     action: "available_payment_option: disable",
  //     affectedOptions: [
  //       "standard_cod"
  //     ],
  //     optionsAfterTheAction: [
  //       "klarna_creeditcard",
  //       "invoice"
  //     ]
  //     },
  //     {
  //       ruleId: 456,
  //       condition: "(application.appId = 2040)",
  //       isMatched: false,
  //       name: "Default shipping",
  //       description: "Deactivate free shipping  as long as collection point type = \"collection points\" is not selected",
  //       action: "available_payment_option: disable"
  //     },
  //     ]
  //   }
  // ],
  // Comment this in to show a notification:
  // notifications: [
  //   {
  //     type: 'info',
  //     textTranslationKey: 'basket.notifications.basketTotalChanged'
  //   }
  // ],
  integrations: {
    newsletter: { customerIsConfirmedSubscriber: false, enabled: true }
  },
  orderOptions: {
    payment: {
      generic: initialPaymentMethods,
      recurring: initialRecurringPaymentMethods
    },
    shipping: {
      collectionPointDelivery: [
        {
          carrierGroupKey: 'hermes',
          carrierKey: 'HERMES_KLV',
          collectionPointType: 'hermes_parcelshop',
          deliveryOptionKey: 'collection_points',
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'collection_point_delivery',
          isDisabled: false
        },
        {
          carrierGroupKey: 'dhl',
          carrierKey: 'DHL_STD_NATIONAL',
          collectionPointType: 'dhl_packstation',
          deliveryOptionKey: 'collection_points',
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'collection_point_delivery',
          isDisabled: false
        },
        {
          carrierGroupKey: 'dhl',
          carrierKey: 'DHL_STD_NATIONAL',
          collectionPointType: 'dhl_postoffice',
          deliveryOptionKey: 'collection_points',
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'collection_point_delivery',
          isDisabled: false
        },
        {
          carrierGroupKey: 'blabla',
          carrierKey: 'BLABLA',
          collectionPointType: 'generic',
          deliveryOptionKey: 'click_and_collect',
          shippingOptionKey: 'standard_delivery',
          serviceCosts: {
            total: 0
          },
          isDisabled: false
        }
      ],
      homeDelivery: [
        {
          carrierGroupKey: 'dhl',
          carrierKey: 'DHL',
          deliveryOptionKey: 'home_delivery',
          deliveryEstimations: {
            deliveryDateTime: {
              iso8601: '2021-04-23T14:00:00+01:00'
            },
            deliveryDays: {
              maximum: 3,
              minimum: 2
            }
          },
          isDisabled: false,
          requiresDateSchedule: false,
          requiresTimeSchedule: false,
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'de_dhl_standard'
        },
        {
          carrierGroupKey: 'dhl',
          carrierKey: 'DHL',
          deliveryOptionKey: 'home_delivery',
          deliveryEstimations: {
            deliveryDateTime: {
              iso8601: '2021-04-22T14:00:00+01:00'
            },
            deliveryDays: {
              maximum: 2,
              minimum: 1
            }
          },
          isDisabled: false,
          requiresDateSchedule: false,
          requiresTimeSchedule: false,
          serviceCosts: {
            total: 794
          },
          shippingOptionKey: 'de_dhl_express'
        },

        {
          carrierGroupKey: 'hermes',
          carrierKey: 'HERMES_STD_NATIONAL',
          deliveryOptionKey: 'home_delivery',
          deliveryEstimations: {
            deliveryDateTime: {
              iso8601: '2021-04-23T14:00:00+01:00'
            },
            deliveryDays: {
              maximum: 3,
              minimum: 2
            }
          },
          isDisabled: false,
          requiresDateSchedule: false,
          requiresTimeSchedule: false,
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'least_packages'
        },

        {
          carrierGroupKey: 'hermes',
          carrierKey: 'HERMES_STD_NATIONAL',
          deliveryOptionKey: 'home_delivery',
          deliveryDates: {
            minimum: format(today, 'yyyy-MM-dd'),
            maximum: format(addMonths(today, 4), 'yyyy-MM-dd')
          },
          isDisabled: false,
          requiresDateSchedule: true,
          requiresTimeSchedule: false,
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'scheduled_delivery'
        }
      ]
    }
  },
  orderState: {
    // Comment this in to always get to the payment step right away:
    addresses: {
      shipping: {
        id: 1,
        hash: '5426',
        country: {
          iso2Code: 'DE'
        },
        salutationCode: 'f',
        firstName: 'Elcha',
        lastName: 'Muyin',
        street: 'Domstr.',
        houseNumber: '10',
        zipCode: '20095',
        city: 'Hamburg',
        forwardToCollectionPoint: false
      },
      billing: {
        id: 1,
        hash: '5426',
        country: {
          iso2Code: 'DE'
        },
        salutationCode: 'f',
        firstName: 'Elcha',
        lastName: 'Muyin',
        street: 'Domstr.',
        houseNumber: '10',
        zipCode: '20095',
        city: 'Hamburg'
      }
    },
    basket: initialBasket as unknown as Basket,
    memberships: {
      suggestions: [{ membershipTypeKey: 'payback', earnings: { points: 12 } }]
    },
    shipping: {
      selected: [
        {
          carrierGroupKey: 'hermes',
          carrierKey: 'HERMES_STD_NATIONAL',
          deliveryOptionKey: 'home_delivery',
          deliveryEstimations: {
            deliveryDateTime: {
              iso8601: '2021-04-23T14:00:00+01:00'
            },
            deliveryDays: {
              maximum: 3,
              minimum: 2
            }
          },
          isDisabled: false,
          requiresDateSchedule: false,
          requiresTimeSchedule: false,
          serviceCosts: {
            total: 0
          },
          shippingOptionKey: 'least_packages'
        }
      ]
    }
  }
};

export default initialState;
